<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Energieeffizienzklasse</h2>
      <p class="step-text">
        In welche Energieeffizienzklasse ist die Immobilie eingestuft?
      </p>
    </div>
    <div class="step-body">
      <div class="box-container box-container-energy">
        <ActionBox
          class="box-item small-icon-w-50"
          text="A oder besser"
          @click="setEnergieklasse(30)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseA.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseA_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="B"
          @click="setEnergieklasse(40)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseB.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseB_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="C"
          @click="setEnergieklasse(50)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseC.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseC_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="D"
          @click="setEnergieklasse(60)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseD.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseD_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="E"
          @click="setEnergieklasse(70)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseE.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseE_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="F"
          @click="setEnergieklasse(80)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseF.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseF_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="G"
          @click="setEnergieklasse(90)"
          :iconDefault="require('@/assets/icons/Svgs/EnergieklasseG.svg')"
          :iconHover="require('@/assets/icons/Svgs/EnergieklasseG_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-50"
          text="Nicht bekannt"
          @click="setEnergieklasse(20)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8390.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8390_white.svg')"
        />
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "wohnung-step-4",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexGebaeudeWaermedaemmung: { value: null },
      },
    };
  },
  methods: {
    setEnergieklasse(index) {
      this.fields.indexGebaeudeWaermedaemmung.value = index;
      saveToStorage(this.fields);
      this.$router.push("/wohnung-step-5");
    },
    goBack() {
      this.$router.push("/wohnung-step-3");
},
  },
  mounted() {
    this.$emit("setStep", "wohnung", 5);
  },
};
</script>
<style scoped>
.box-container {
  gap: 30px;
}
.box-item {
  flex-basis: 210px !important;
  height: 190px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    gap: 20px;
  }
  .box-item {
    height: 100%;
  }
}
</style>
